export const MEASURE_DETAIL_TAB = {
  overview: 'overview',
  savingsPotential: 'savingspotential',
  valeri: 'valeri',
  baseline: 'baseline',
  documentation: 'documentation',
} as const

export type MeasureDetailTab = (typeof MEASURE_DETAIL_TAB)[keyof typeof MEASURE_DETAIL_TAB]

export const MEASURE_DETAIL_TAB_QUERY_PARAM = 't'

const MEASURE_DETAIL_TAB_VALUES: MeasureDetailTab[] = Object.values(MEASURE_DETAIL_TAB)

const LEGACY_MEASURE_DETAIL_TAB_INDEXES: Record<string, MeasureDetailTab> = {
  '0': MEASURE_DETAIL_TAB.overview,
  '1': MEASURE_DETAIL_TAB.savingsPotential,
  '2': MEASURE_DETAIL_TAB.valeri,
  '3': MEASURE_DETAIL_TAB.baseline,
  '4': MEASURE_DETAIL_TAB.documentation,
}

export const parseMeasureDetailTab = (raw: string | null): MeasureDetailTab => {
  if (!raw) return MEASURE_DETAIL_TAB.overview

  const normalized = raw.trim().toLowerCase()
  if (MEASURE_DETAIL_TAB_VALUES.includes(normalized as MeasureDetailTab)) return normalized as MeasureDetailTab

  return LEGACY_MEASURE_DETAIL_TAB_INDEXES[normalized] ?? MEASURE_DETAIL_TAB.overview
}
